<script setup lang="ts">
// Loading placeholder for the lazily-loaded MapLocation component (BC-40).
// Mirrors the MapLocation container dimensions so the map chunk can load after
// first paint without any layout shift.
//
// MON-42: on mobile the map is opt-in. When `interactive` is set, the
// placeholder becomes a tappable "Show map" surface that emits `load` instead
// of mapbox-gl auto-loading. It reuses the exact same reserved height as the
// plain loading box, so switching between them causes no layout shift.
withDefaults(
    defineProps<{
        interactive?: boolean
        label?: string
    }>(),
    {
        interactive: false,
        label: "Show map",
    },
)

defineEmits<{
    (e: "load"): void
}>()
</script>

<template>
    <div class="relative h-full">
        <button
            v-if="interactive"
            type="button"
            class="sticky top-32 w-full h-[50vh] lg:h-[80vh] bg-neutral-100 flex flex-col items-center justify-center gap-2 text-blue-500 font-title font-bold uppercase text-sm leading-none cursor-pointer transition-colors hover:bg-neutral-200"
            @click="$emit('load')"
        >
            <svg
                class="w-7 h-7"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M9 18l-6 2V6l6-2 6 2 6-2v14l-6 2-6-2z" />
                <path d="M9 4v14M15 6v14" />
            </svg>
            {{ label }}
        </button>
        <div
            v-else
            class="sticky top-32 w-full h-[50vh] lg:h-[80vh] bg-neutral-100"
        ></div>
    </div>
</template>
